var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransitionWrapper',_vm._g({staticClass:"bounce-graphic-wrapper",attrs:{"auto-hide":""}},_vm.$listeners),[_c('img',{staticClass:"bounce-graphic",attrs:{"src":require(("@/assets/images/" + _vm.image)),"alt":_vm.label}})])}
var staticRenderFns = []

export { render, staticRenderFns }